import {
  SET_COLUMNS,
  SET_CURRENT_PERSON_COLUMNS,
  SET_CURRENT_COMPANY_COLUMNS
} from '../actions/session';

export default function (state = {}, action) {
  switch (action.type) {
  case SET_COLUMNS:
    return { ...state, currentColumns: action.columns };
  case SET_CURRENT_PERSON_COLUMNS:
    return { ...state, currentPersonColumns: action.columns };
  case SET_CURRENT_COMPANY_COLUMNS:
    return { ...state, currentCompanyColumns: action.columns };
  default:
    return state;
  }
}
